// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import { validRadioCode } from 'helpers/regex'

import {
  valueIsRequired,
  valueMustBeWithinMaxLength,
} from 'validators/common'

// NOTE - this supports both radioCode and legacyRadioCode
// However it does NOT support favoriteRadioCode!

const validateRadioCode = (v, required = false) => (
  (required && valueIsRequired(v)) ||

  // radioCode and legacyRadioCode cannot be greater than 6 characters
  valueMustBeWithinMaxLength(v, 6) ||

  // make sure that the value has length, if it does,
  // make sure it matches the regex for valid legacy radio code
  // otherwise, display the error message
  (!!v && v.match(validRadioCode) === null && 'Allowed characters are A-Z, 0-9 and #.')
)

export default validateRadioCode
